import GoalDetailsModal from './GoalDetailsModal';

export default GoalDetailsModal;

